import { ApolloLink, from } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { getCookies, removeCookies } from '@/utils/auth.js';
import { Message } from 'element-ui';
import { apiUrl } from './url.js';

// GraphQL
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';

const httpLink = new HttpLink({
    uri: apiUrl
});

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    const token = getCookies('userToken');
    if (operation.operationName !== 'adminLogin') {
        operation.setContext({
            headers: {
                authorization: `Bearer ${token || null}`
            }
        });
    }
    return forward(operation);
});

const checkCodeLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
        if (response.code === 401) {
            // TODO
            // 根据状态码处理
        }
        return response;
    });
});

const errorLink = onError(({ networkError, graphQLErrors }) => {
    if (graphQLErrors && graphQLErrors[0].extensions.code === 'UNAUTHENTICATED') {
        // TODO
        // 这里跳转到登录重新授权
        removeCookies('userToken');
        Message({
            message: '请先登录',
            type: 'error',
            duration: 3000
        });
        setTimeout(() => {
            window.location.href = `https://www.madagx.com/wxauth/login.html?appid=wx7e700089d1cc517d&scope=snsapi_login&state=${Math.ceil(Math.random() * 1000)}&redirect_uri=${encodeURIComponent('https://styw.madagx.com')}`;
        }, 2000);
    }
});

export const link = from([
    authMiddleware,
    checkCodeLink,
    errorLink,
    httpLink
]);

// Create the apollo client
export const apolloClient = new ApolloClient({
    link: link,
    cache: new InMemoryCache(),
    connectToDevTools: true
});

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient
});



// WEBPACK FOOTER //
// ./src/graphql/apply-ware.js